import { Locale } from '@/types/locale';

export const CS_LINKS = {
	aboutCompany: '/o-skippay',
	aboutDeferredPayment: '/odlozena-platba',
	packages: '/nase-produkty',
	allProducts: '/nase-produkty',
	productsPackages: '/nase-produkty#products-packages',
	bankTransfer: '/prevod-penez',
	card: '/karta',
	career: '/kariera',
	careerList: '/kariera/volne-pozice',
	careerDetail: (slug: string) => `/kariera/${slug}/`,
	contact: '/kontakty',
	contracts: '/contracts-and-documents/contracts',
	conditions: '/vseobecne-obchodni-podminky',
	creditCard: '/kreditni-karta',
	deferredPayment: '/platba-skip-pay',
	discounts: '/slevy',
	discountsCategory: (slug: string) => `/slevy/kategorie/${slug}`,
	discountsDetail: (slug: string) => `/slevy/${slug}`,
	exchangeRates: '/kurzovni-listek',
	faq: '/caste-dotazy',
	faqCategory: (slug: string) => `/caste-dotazy/${slug}`,
	faqQuestion: (categorySlug: string, questionSlug: string) =>
		`/caste-dotazy/${categorySlug}/${questionSlug}`,
	forDevelopers: '/pro-vyvojare',
	forEshops: '/pro-eshop',
	forMedia: '/pro-novinare',
	homepage: '/',
	howToPay: '/jak-zaplatit',
	informationMemorandum: '/informacni-memorandum',
	installments: '/splatky',
	installmentPayment: '/nakup-na-splatky',
	insurance: '/pojisteni-ke-karte',
	investments: '/investuj-pri-nakupovani',
	loan: '/pujcka',
	loans: '/pujcky',
	login: '/login',
	mobileApp: '/mobilni-aplikace',
	onlinePayment: '/platba-online',
	otherDocuments: '/ostatni-dokumenty',
	overdraft: '/kontokorent',
	payInThree: '/nakup-na-tretinu',
	paymentByCard: '/platba-kartou',
	paymentGateway: '/platebni-brana',
	paymentOnDelivery: '/dobirka',
	personalInformation: '/sprava-osobnich-udaju',
	postponeDueDate: '/odlozeni-splatnosti',
	pricing: '/cenik',
	privacySettings: '/nastaveni-soukromi',
	pressReleases: '/tiskove-zpravy',
	pressReleaseDetail: (slug: string) => `/tiskove-zpravy/${slug}`,
	promotions: '/slevy',
	referral: '/doporucte-nas',
	registration: '/registration',
	retention: '/zruseni-skip-pay',
	rewards: '/odmeny',
	revolving: '/balicek-maxi',
	shopWisely: '/nakupujte-s-rozumem',
	testimonial: '/recenze-klientu',
	termsAndConditions: '/dokumenty',
	whereToShop: '/kde-nakupovat',
	wroteAboutUs: '/napsali-o-nas',
	youShopWePay: '/my-to-platime',
	whistleblowing: '/whistleblowing',
	gcssLandingPage: '/css-program',
	gcssHomepage: '/srovnavac-produktu',
	gcssHomepageSearch: '/srovnavac-produktu/vyhledavani',
	gcssCategory: (slug: string) => `/srovnavac-produktu/${slug}`,
	gcssSubCategory: (slugs: string[]) =>
		`/srovnavac-produktu/${slugs.map((slug) => slug).join('/')}`,
	extendedWarranty: '/prodlouzena-zaruka',
	partners: '/partneri',
	insuranceReport: '/hlaseni-skody',
	insuranceAndWarranty: '/pojisteni',
};

export const SK_LINKS = {
	aboutCompany: '/o-skippay',
	aboutDeferredPayment: '/',
	packages: '/',
	allProducts: '/',
	productsPackages: '/',
	bankTransfer: '/',
	card: '/',
	career: '/',
	careerList: '/',
	careerDetail: () => '/',
	contact: '/kontakty',
	contracts: '/contracts-and-documents/contracts',
	conditions: '/vseobecne-obchodne-podmienky',
	creditCard: '/',
	deferredPayment: '/',
	discounts: '/',
	discountsCategory: () => '/',
	discountsDetail: () => '/',
	exchangeRates: '/',
	faq: '/casto-kladene-otazky',
	faqCategory: (slug: string) => `/casto-kladene-otazky/${slug}`,
	faqQuestion: (categorySlug: string, questionSlug: string) =>
		`/casto-kladene-otazky/${categorySlug}/${questionSlug}`,
	forDevelopers: '/pre-vyvojarov',
	forEshops: '/pre-eshop',
	forMedia: '/pre-novinarov',
	homepage: '/',
	howToPay: '/',
	informationMemorandum: '/informacne-memorandum',
	installments: '/',
	installmentPayment: '/',
	insurance: '/',
	investments: '/',
	loan: '/',
	loans: '/',
	login: '/login',
	mobileApp: '/mobilna-aplikacia',
	onlinePayment: '/',
	otherDocuments: '/ostatne-dokumenty',
	overdraft: '/',
	payInThree: '/nakup-na-tretinu',
	paymentByCard: '/',
	paymentGateway: '/',
	paymentOnDelivery: '/',
	personalInformation: '/sprava-osobnych-udajov',
	postponeDueDate: '/',
	pricing: '/cennik',
	privacySettings: '/nastavenie-sukromia',
	pressReleases: '/',
	pressReleaseDetail: () => '/',
	promotions: '/',
	referral: '/',
	registration: '/registration',
	retention: '/',
	rewards: '/',
	revolving: '/',
	shopWisely: '/',
	testimonial: '/',
	termsAndConditions: '/dokumenty',
	whereToShop: '/kde-nakupovat',
	wroteAboutUs: '/',
	youShopWePay: '/',
	whistleblowing: '/whistleblowing',
	gcssLandingPage: '/',
	gcssHomepage: '/',
	gcssHomepageSearch: '/',
	gcssCategory: () => '/',
	gcssSubCategory: () => '/',
	extendedWarranty: '/',
	partners: '/partneri',
	insuranceReport: '/',
	insuranceAndWarranty: '/',
};

// TODO: Update links when available
export const HU_LINKS = {
	aboutCompany: '/about-skippay',
	aboutDeferredPayment: '/',
	packages: '/',
	allProducts: '/',
	productsPackages: '/',
	bankTransfer: '/',
	card: '/',
	career: '/career',
	careerList: '/career/vacant-positions',
	careerDetail: (slug: string) => `/career/${slug}/`,
	contact: '/contact',
	contracts: '/contracts-and-documents/contracts',
	conditions: '/terms-and-conditions',
	creditCard: '/',
	deferredPayment: '/',
	discounts: '/',
	discountsCategory: () => '/',
	discountsDetail: () => '/',
	exchangeRates: '/',
	faq: '/faq',
	faqCategory: (slug: string) => `/faq/${slug}`,
	faqQuestion: (categorySlug: string, questionSlug: string) =>
		`/faq/${categorySlug}/${questionSlug}`,
	forDevelopers: '/for-developers',
	forEshops: '/for-eshop',
	forMedia: '/for-journalist',
	homepage: '/',
	howToPay: '/',
	informationMemorandum: '/information-memorandum',
	installments: '/',
	installmentPayment: '/',
	insurance: '/',
	investments: '/',
	loan: '/',
	loans: '/',
	login: '/login',
	mobileApp: '/mobile-app',
	onlinePayment: '/',
	otherDocuments: '/other-documents',
	overdraft: '/',
	payInThree: '/pay-in-three',
	paymentByCard: '/',
	paymentGateway: '/',
	paymentOnDelivery: '/',
	personalInformation: '/personal-data-management',
	postponeDueDate: '/',
	pricing: '/pricing',
	privacySettings: '/privacy-settings',
	pressReleases: '/',
	pressReleaseDetail: () => '/',
	promotions: '/',
	referral: '/',
	registration: '/registration',
	retention: '/',
	rewards: '/',
	revolving: '/',
	shopWisely: '/',
	testimonial: '/',
	termsAndConditions: '/documents',
	whereToShop: '/where-to-shop',
	wroteAboutUs: '/',
	youShopWePay: '/',
	whistleblowing: '/whistleblowing',
	gcssLandingPage: '/',
	gcssHomepage: '/',
	gcssHomepageSearch: '/',
	gcssCategory: () => '/',
	gcssSubCategory: () => '/',
	extendedWarranty: '/',
	partners: '/partners',
	insuranceReport: '/',
	insuranceAndWarranty: '/',
};

export const LINKS = (locale: Locale = process.env.NEXT_PUBLIC_LANGUAGE || 'cs') => {
	switch (locale) {
		case 'cs':
			return CS_LINKS;
		case 'sk':
			return SK_LINKS;
		case 'hu':
			return HU_LINKS;
		default:
			throw new Error('Locale is not supported yet');
	}
};

export const SELF_CARE_LINKS = {
	rewardsOverview: '/rewards',
	rewardsOverviewDetail: (id: string) => `/rewards/${id}`,
	paymentCard: '/payment-card',
	referral: '/referral',
	overview: '/overview',
} as const;

export const EXTERNAL_LINKS = (): Record<
	| 'facebook'
	| 'linkedIn'
	| 'instagram'
	| 'youtube'
	| 'blog'
	| 'podcast'
	| 'affiliate'
	| 'glossaryOfTerms'
	| 'appStore'
	| 'googlePlay'
	| 'googleTestimonials'
	| 'csob'
	| 'csobGroup'
	| 'map'
	| 'marketingPromos'
	| 'developersPortal'
	| 'developersPortalAPI'
	| 'developersPortalGuides'
	| 'atmoskop'
	| 'checkoutManual'
	| 'checkoutManualSk'
	| 'checkoutManualHu'
	| 'stopDobirce',
	string
> & {
	blogLink: (path: string) => string;
	glossaryOfTermsLink: (path: string) => string;
} => {
	const blog = 'https://skippay.cz/blog';
	const glossaryOfTerms = `${blog}/slovnik-pojmu`;

	return {
		affiliate: 'https://promo.skippay.cz/affiliate/',
		appStore: 'https://apps.apple.com/app/id1450758826',
		atmoskop:
			'https://www.atmoskop.cz/nazory-na-zamestnavatele/3409-skip-pay-s-r-o/hodnoceni/2#main',
		blog,
		blogLink: (path: string) => `${blog}/${path}`,
		csob: 'https://csob.cz/',
		csobGroup: 'https://www.csob.cz/csob/o-csob-a-skupine',
		facebook: 'https://www.facebook.com/SkipPay/',
		glossaryOfTerms,
		glossaryOfTermsLink: (path: string) => `${glossaryOfTerms}/${path}`,
		googlePlay: 'https://play.google.com/store/apps/details?id=cz.mallpay&hl=cs',
		googleTestimonials:
			'https://www.google.com/search?sxsrf=ALeKk03EmIM5XfCEdYxv8qRdo-SuODVfDw:1607332983074&q=MALL+Pay&stick=H4sIAAAAAAAAAONgecR4hJFb4OWPe8JSuxgnrTl5jXEzIxdXcEZ-uWteSWZJpVAAFxuUpcIlKMWrn65vaJhWlVdhmJdWrMEgxc-FKiSloMTFW-55VVZ02Y-ZHFpCnPLXrk0KmSLkLnhkwYxnXw7duKQUbOS-69K0c2yOggxAULM7yEFKU0uIi92z2Cc_OTFH8PR8-WyzVbPstYS5OEISK_Lz8nMrBdOf_d9_7v97eyVOTqCmA_5rrtprMTTtW3GIjYWDUYCBZxErh6-jj49CQGIlAOxqz8_VAAAA#lrd=0x4712945492d6d61f:0xd2d8c2f4e698a0c4,1,,,',
		linkedIn: 'https://www.linkedin.com/company/skip-pay/',
		instagram: 'https://www.instagram.com/skip_pay/',
		map: 'https://maps.app.goo.gl/2kfSHNQAQuJe7ZwS9',
		podcast: 'https://skippay.cz/blog/tema/podcasty/',
		youtube: 'https://www.youtube.com/channel/UC56ivZwb5fjA7ClI49aMyIg',
		marketingPromos: 'https://promo.skippay.cz/nase-akce',
		developersPortal: 'https://developers.skippay.eu/',
		developersPortalAPI: 'https://developers.skippay.eu/docs/api-reference/overview',
		developersPortalGuides: 'https://developers.skippay.eu/docs/category/introduction',
		checkoutManual: 'https://promo.skippay.cz/pro-eshopy/navody/checkout-manual#checkout',
		checkoutManualSk: 'https://promo.skippay.cz/sk/pre-eshopy/navody/checkout-manual',
		checkoutManualHu: 'https://promo.skippay.cz/hu/webaruhazaknak/utmutatok/checkout-manual',
		stopDobirce: 'https://stopdobirce.cz/',
	};
};

export const SHARE_LINKS = (
	url: string
): Record<'whatsApp' | 'facebook' | 'x' | 'messenger' | 'linkedIn', string> => {
	return {
		whatsApp: `https://wa.me/?text=${encodeURIComponent(url)}`,
		facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
		messenger: `https://www.facebook.com/dialog/send?app_id=${
			process.env.NEXT_PUBLIC_FACEBOOK_APP_ID
		}&link=${encodeURIComponent(url)}&redirect_uri=${encodeURIComponent(url)}`,
		x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
		linkedIn: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
	};
};
